export const MessageModel: {
  content: string
  groupId: number | null
  restricted: boolean
  language?: string
} = {
  content: "",
  groupId: null,
  restricted: true
} 

export const MessageValidator = {
  content: [
    {
      required: true,
      trigger: "blur",
      transform: (value: string) => value.trim()
    }
  ],
  restricted: {
    type: "boolean",
    trigger: "blur"
  }
}

export const ReportModel: {
  reason?: string
} = {
  reason: ""
}

export const ReportValidator = {
  reason: {
    trigger: "blur",
    transform: (value: string) => value.trim()
  }
}
